const ValidationErrors = ({ errors = [], onClose }) => {
    if (!Array.isArray(errors) || errors.length === 0) return null;

    return (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
            {errors.map((err, index) => (
                <p key={index} className="mb-1">{err?.msg}</p>
            ))}
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={onClose}></button>
        </div>
    );
};

export default ValidationErrors;